import React from 'react'
import AppLayout from '../../../../layout/components/AppLayout'
import { NavLink } from 'react-router-dom'

function ScheduleLayout({children}) {
  return (
    <AppLayout>
        <div className='container-fluid'>        
            <div className='row'>
                <div className='col-md-3'>
                    <div className='list-group'>
                        <NavLink to={"/schedule/business-hours"} className="list-group-item list-group-item-action">Business Hours</NavLink>
                        <NavLink to={"/schedule/business-holiday"} className="list-group-item list-group-item-action">Business Holiday</NavLink>
                    </div>
                </div>
                <div className='col-md-9'>
                    {children}
                </div>
            </div>
        </div>
            
    </AppLayout>
    )
}

export default ScheduleLayout